// extracted by mini-css-extract-plugin
module.exports = {"vStack":"stack_vStack__3Qh6Z","hStack":"stack_hStack__32e8R"};